export default __webpack_public_path__ + "static/app_store_icon-036f945a7c53edba9863294d7267b5f7.svg";